import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const CampaignContext = createContext({ campaign: null });

export function CampaignProvider({ children }) {
    const [campaign, setCampaign] = useState(null);

    useEffect(() => {
        let alive = true;
        const fetchIt = () => {
            api.get("/campaign")
                .then(({ data }) => { if (alive) setCampaign(data?.active ? data : null); })
                .catch(() => { if (alive) setCampaign(null); });
        };
        fetchIt();
        // refresh every 2 min so the banner reflects admin toggles / end time
        const t = setInterval(fetchIt, 120000);
        return () => { alive = false; clearInterval(t); };
    }, []);

    return (
        <CampaignContext.Provider value={{ campaign }}>
            {children}
        </CampaignContext.Provider>
    );
}

export function useCampaign() {
    return useContext(CampaignContext);
}
